import { Box, Typography, Paper, Avatar, Chip, Tooltip } from '@mui/material';
import { formatDistanceToNow, format } from 'date-fns';

import { CommentEntity } from '@/types/api';

export interface CommentItemProps {
  comment: CommentEntity;
  showDivider?: boolean;
}

export const CommentItem = ({ comment, showDivider = false }: CommentItemProps) => {
  const formatCommentDate = (date: number) => {
    try {
      return formatDistanceToNow(new Date(date), { addSuffix: true });
    } catch {
      return date;
    }
  };

  const formatFullTimestamp = (date: number) => {
    try {
      return format(new Date(date), 'PPpp');
    } catch {
      return new Date(date).toLocaleString();
    }
  };

  const getUserDisplayName = () => {
    return comment.author.name || comment.authorId;
  };

  const getUserInitial = () => {
    const name = comment.author.name || comment.authorId;
    return name.charAt(0).toUpperCase();
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, py: 1 }}>
        <Avatar sx={{ width: 32, height: 32 }}>{getUserInitial()}</Avatar>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Typography variant="subtitle2" component="span">
              {getUserDisplayName()}
            </Typography>
            <Tooltip title={formatFullTimestamp(comment.createdAt)} arrow>
              <Chip
                label={formatCommentDate(comment.createdAt)}
                size="small"
                variant="outlined"
                sx={{ fontSize: '0.75rem', height: 20, cursor: 'default' }}
              />
            </Tooltip>
          </Box>
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              backgroundColor: 'grey.50',
              borderRadius: 2,
            }}
          >
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {comment.content}
            </Typography>
          </Paper>
        </Box>
      </Box>
      {showDivider && <Box sx={{ borderBottom: 1, borderColor: 'divider', my: 1 }} />}
    </Box>
  );
};
